import { useState } from "react";
import { View } from "react-native";
import { ModalComponentProps, ModalWrapperWithHeader } from "src/modals";
import { paddingLarge, paddingMedium } from "src/styles/spacing";
import ShareableActions from "./components/ShareableActions";
import ShareablePreview from "./components/ShareablePreview";
import useShareableResolvedProps from "./hooks/useShareableResolvedProps";
import { useShareableModalDimensions } from "./ShareableModalSkeleton";
import { ShareableProcessingState } from "./types";

const ShareableModal = ({ variant }: ModalComponentProps) => {
	const [processingState, setProcessingState] = useState<ShareableProcessingState>("Idle");
	const { resolvedProps } = useShareableResolvedProps();
	const style = useShareableModalDimensions();

	return (
		<View style={style}>
			<ModalWrapperWithHeader variant={variant}>
				{!resolvedProps?.success && resolvedProps?.ErrorComponent ? (
					<resolvedProps.ErrorComponent />
				) : (
					<>
						<ShareablePreview
							style={{
								marginTop: paddingMedium,
								flex: 1,
							}}
							processingState={processingState}
							resolvedProps={resolvedProps}
						/>
						<ShareableActions
							style={{
								marginTop: paddingLarge,
							}}
							onShareInitiated={() => setProcessingState("Processing")}
							onProcessingCompleted={() => setProcessingState("Success")}
							resolvedProps={resolvedProps}
						/>
					</>
				)}
			</ModalWrapperWithHeader>
		</View>
	);
};
export default ShareableModal;
